import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { textXSObj: text4 } = typographyStyles;

const { mediaQuery } = mediaQueryStyles;
const { colors } = constants;
const {
  BreakpointNames: { xs },
} = constants.breakpoints;

export const assignmentInfoCss = {
  display: "flex",
  justifyContent: "center",

  [mediaQuery.upTo(xs)]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
};

export const assignmentInfoColumnCss = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",

  "&:not(:last-child)": {
    marginRight: "40px",
  },

  [mediaQuery.upTo(xs)]: {
    alignItems: "flex-start",
    margin: "0 0 16px 0",
  },
};

export const labelCss = {
  color: colors.ui.neutral[400],
  letterSpacing: "1px",
  margin: "0 0 8px 0",
  textTransform: "uppercase",
  ...text4,
};

export const valueCss = {
  fontWeight: "bold",
  margin: 0,
};
